import { createMutationHook } from '~/shared/providers/api';

export const useCreateFreightLaneMutation = createMutationHook(
  'transportation.freightLaneCreate',
  (params: {
    carrierId: string;
    transportationMode: string;
    active: boolean;
    freightLaneRouteId?: string;
    equipmentType?: string;
    commodityCategory?: string;
    originLocationId?: string;
    originLocationType?: string;
    destinationCity?: string;
    destinationState?: string;
    destinationZipCode?: string;
    destinationCountry?: string;
    notes?: string;
  }) => ({
    transportationFreightLaneCreate: {
      __args: {
        input: {
          carrierId: params.carrierId,
          transportationMode: params.transportationMode,
          active: params.active,
          freightLaneRouteId: params.freightLaneRouteId,
          equipmentType: params.equipmentType,
          commodityCategory: params.commodityCategory,
          originLocationId: params.originLocationId,
          originLocationType: params.originLocationType,
          destinationCity: params.destinationCity,
          destinationState: params.destinationState,
          destinationZipCode: params.destinationZipCode,
          destinationCountry: params.destinationCountry,
          notes: params.notes,
        },
      },
      id: true,
      carrierId: true,
      transportationMode: true,
      equipmentType: true,
      commodityCategory: true,
      active: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
